import template from './sw-cms-preview-acris-blog-title.html.twig';
import './sw-cms-preview-acris-blog-title.scss';

const { Component } = Shopware;

Component.register('sw-cms-preview-acris-blog-title', {
    template
});
